import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MaintenanceWindowsDeleteDialogDataProviderFactory } from '../factory/MaintenanceWindowsDeleteDialogDataProviderFactory';
import { MaintenanceWindowsDeleteDialogBaseDataProvider } from '../dataProvider/MaintenanceWindowsDeleteDialogBaseDataProvider';
import { PolicyImpactData } from '../types';

export class MaintenanceWindowsDeleteDialogRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MaintenanceWindowsDeleteDialogDataProviderFactory;
  public dataProvider: MaintenanceWindowsDeleteDialogBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MaintenanceWindowsDeleteDialogDataProviderFactory(),
    });
  }

  async getDataForView(companyId: string, maintenanceWindowIds: string[]): Promise<PolicyImpactData> {
    return this.dataProvider.getMaintenanceWindowOperationSummary(companyId, maintenanceWindowIds);
  }
}
